import { CheckboxComponent } from './checkbox/checkbox.component';
import { InputComponent } from './input';
import { InputHintComponent } from './input-hint/input-hint.component';
import { MustCheckValidatorDirective } from './checkbox/mustcheck.validator';
import { SectionComponent, SectionBodyDirective } from './section';
import { SelectComponent } from './select/select.component';
import { HelpComponent } from './help/help.component';
import { InputPasswordComponent,
         InputPasswordVisibilityToggleComponent,
         InputPasswordPolicyMessageComponent,
         PasswordPolicyValidatorDirective } from './input-password';

export const declarations = [
  CheckboxComponent,
  InputComponent,
  InputHintComponent,
  MustCheckValidatorDirective,
  SectionBodyDirective,
  SectionComponent,
  SelectComponent,
  InputPasswordComponent,
  InputPasswordVisibilityToggleComponent,
  InputPasswordPolicyMessageComponent,
  PasswordPolicyValidatorDirective,
  HelpComponent
];
